import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { SITE_CONTEXT_FEATURE, SiteContextState, StateWithSiteContext } from '../site-context-state';

export const getSiteContextState: MemoizedSelector<StateWithSiteContext, SiteContextState> =
  createFeatureSelector<SiteContextState>(SITE_CONTEXT_FEATURE);
